import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import Swal from "sweetalert2";
import { storeCategoryServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCategoryServices";

const UpdateCategory = ({
  show,
  hide,
  title,
  storeCategoryData,
  getStoreCategoryList,
  setStoreCategoryData,
  setStoreCategoryIds,
  getActiveStoreCategoryList
}) => {
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);

  const updatedStoreCategory = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to update this Store Category?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, update it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true)
        let userData = {}
        userData.categoryId = storeCategoryData?.categoryId
        userData.name = name
        let data = await storeCategoryServices.updatedStoreCategory(userData)
        if (data?.statusCode === 200) {
          clearData();
          getStoreCategoryList()
          getActiveStoreCategoryList()
          setStoreCategoryIds([])
          setStoreCategoryData("")
        }
        setLoader(false)
      }
    });
  };

  const clearData = () => {
    setName("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (show && storeCategoryData) {
      setName(storeCategoryData?.name);
      setLoader(false)
    }
  }, [show, storeCategoryData]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button style={{ fontSize: 12 }} variant="light" onClick={clearData}>
              Cancel
            </Button>
            <Button
              onClick={updatedStoreCategory}
              disabled={!name || loader}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default UpdateCategory;
